import { FC } from 'react';

import { IMarkedListSchema } from 'shared/repositories/commercial-search-offers/entities/marked_list/MarkedListSchema';
import { isLastListItem } from 'shared/utils/array/isLastListItem';

import { Accordion } from './internal/components/Accordion';

import styles from './MarkedList.css';

type MarkedListProps = {
  items: IMarkedListSchema[];
};

export const MarkedList: FC<MarkedListProps> = props => {
  const { items } = props;

  return (
    <div className={styles['container']} data-testid="seo.marked-list">
      {items.reduce((accumulator, item, index, arr) => {
        const { content, title } = item;

        const id = `SeoMarkedListItem_${index}`;

        if (content && title) {
          const headingId = `${id}_heading`;
          const bodyId = `${id}_body`;

          accumulator.push(
            <Accordion
              bodyId={bodyId}
              bottomBorder={!isLastListItem(arr, index)}
              content={content}
              headingId={headingId}
              key={`${content}${title}`}
              title={title}
            />,
          );
        }

        return accumulator;
      }, Array.of<JSX.Element>())}
    </div>
  );
};
